const openDatabase = () => {
  console.log("🗄️ [Client] openDatabase: Opening IndexedDB connection...");
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("mediuk-email-db", 1);
    request.onupgradeneeded = (event) => {
      console.log("🔄 [Client] openDatabase: Database upgrade needed, creating object store...");
      const db = event.target.result;
      if (!db.objectStoreNames.contains("emails")) {
        db.createObjectStore("emails", { keyPath: "id", autoIncrement: true });
        console.log("✅ [Client] openDatabase: Object store 'emails' created");
      }
    };
    request.onsuccess = (event) => {
      console.log("✅ [Client] openDatabase: Database opened successfully");
      resolve(event.target.result);
    };
    request.onerror = (event) => {
      console.error("❌ [Client] openDatabase: Database opening failed:", event.target.error);
      reject(event.target.error);
    };
  });
};

export const saveEmailToDB = async (email) => {
  console.log("💾 [Client] saveEmailToDB: Attempting to save email to IndexedDB:", email);
  try {
    const db = await openDatabase();
    const transaction = db.transaction("emails", "readwrite");
    const store = transaction.objectStore("emails");
    const result = store.add(email);

    result.onsuccess = () => {
      console.log("✅ [Client] saveEmailToDB: Email saved successfully to IndexedDB");
    };
    
    result.onerror = (event) => {
      console.error("❌ [Client] saveEmailToDB: Failed to save email:", event.target.error);
    };

    // Also notify the service worker that an email was saved
    if ('serviceWorker' in navigator) {
      console.log("📨 [Client] saveEmailToDB: Notifying service worker about saved email");
      navigator.serviceWorker.ready.then(registration => {
        if (registration.active) {
          registration.active.postMessage({
            type: 'EMAIL_SAVED',
            form_data: email
          });
          console.log("✅ [Client] saveEmailToDB: Service worker notified");
        }
      }).catch(error => {
        console.error("❌ [Client] saveEmailToDB: Failed to notify service worker:", error);
      });
    }

    return transaction.complete;
  } catch (error) {
    console.error("💥 [Client] saveEmailToDB: Critical error saving email:", error);
    throw error;
  }
};

export const getEmailsFromDB = async () => {
  console.log("📖 [Client] getEmailsFromDB: Retrieving emails from IndexedDB...");
  try {
    const db = await openDatabase();
    const transaction = db.transaction("emails", "readonly");
    const store = transaction.objectStore("emails");
    return new Promise((resolve, reject) => {
      const request = store.getAll();
      request.onsuccess = () => {
        console.log("✅ [Client] getEmailsFromDB: Retrieved", request.result.length, "emails from IndexedDB");
        resolve(request.result);
      };
      request.onerror = (event) => {
        console.error("❌ [Client] getEmailsFromDB: Failed to retrieve emails:", event.target.error);
        reject(event.target.error);
      };
    });
  } catch (error) {
    console.error("💥 [Client] getEmailsFromDB: Critical error retrieving emails:", error);
    throw error;
  }
};

export const clearEmailsFromDB = async () => {
  console.log("🗑️ [Client] clearEmailsFromDB: Clearing all emails from IndexedDB...");
  try {
    const db = await openDatabase();
    const transaction = db.transaction("emails", "readwrite");
    const store = transaction.objectStore("emails");
    const result = store.clear();
    
    result.onsuccess = () => {
      console.log("✅ [Client] clearEmailsFromDB: All emails cleared from IndexedDB");
    };
    
    result.onerror = (event) => {
      console.error("❌ [Client] clearEmailsFromDB: Failed to clear emails:", event.target.error);
    };
    
    return transaction.complete;
  } catch (error) {
    console.error("💥 [Client] clearEmailsFromDB: Critical error clearing emails:", error);
    throw error;
  }
};